import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IsfV1Model } from '@data-layer/models/isf-v1';
import { WidgetsService } from '@services/widgets.service';
import { enumIsfState } from '@data-layer/enums/isf';
import { enumEntrySummaryState } from '@data-layer/enums/entry-summaries';
import { EntrySummaryModel } from '@data-layer/models/entry-summaries';
import { enumBondRequestState } from '@data-layer/enums/common';
import { BondRequestModel } from '@data-layer/models/common';

@Component({
  selector: 'status-success',
  templateUrl: './status-success.component.html',
  styleUrls: ['./status-success.component.scss'],
})
export class StatusSuccessComponent implements OnInit {
  @Input() public currIsf: IsfV1Model;
  @Input() public currES: EntrySummaryModel;
  @Input() public currBondRequest: BondRequestModel;
  @Input() public isDelivery: boolean;
  @Output() public goToEdit: EventEmitter<any> = new EventEmitter<any>();

  public isWarning: boolean = false;

  private isIsf: boolean = true;
  private isES: boolean = false;
  private isBondRequest: boolean = false;

  constructor(private widgetsService: WidgetsService) {}

  public ngOnInit(): void {
    this.isIsf = !!(this.currIsf && this.currIsf.id);
    this.isES = !!(this.currES && this.currES.id) && !this.isDelivery;
    this.isBondRequest = !!(this.currBondRequest && this.currBondRequest);

    this.checkWarning();
  }

  public get isShowBondPurchaseText(): boolean {
    return (
      (this.isIsf && this.currIsf.bondRequest && this.currIsf.bondRequest.state !== enumBondRequestState.COMPLETED) ||
      (this.isES && this.currES.bondRequest && this.currES.bondRequest.state !== enumBondRequestState.COMPLETED)
    );
  }

  public get referenceNumber(): string {
    return this.isIsf
      ? this.currIsf.referenceNumber
      : this.isES || this.isDelivery
      ? this.currES.referenceNumber
      : this.isBondRequest
      ? this.currBondRequest.referenceNumber
      : '';
  }

  public get code() {
    return this.isIsf
      ? 'LABELS.ISF'
      : this.isES
      ? 'LABELS.ENTRY_SUMMARY'
      : this.isDelivery
      ? 'MESSAGE_CODE.DELIVERY'
      : this.isBondRequest
      ? 'FORM_LABEL.BOND_REQUEST'
      : '';
  }

  public get title(): string {
    return this.isIsf
      ? 'INFO.RESULT.SUCCESS.TITLE.WAS_SUBMITTED_SUCCESSFULLY'
      : this.isES
      ? this.esTitle
      : this.isDelivery
      ? 'INFO.RESULT.SUCCESS.TITLE.YOU_MADE_IT'
      : this.isBondRequest
      ? 'INFO.RESULT.SUCCESS.TITLE.YOU_MADE_IT'
      : '';
  }

  public get subTitle(): string {
    return this.isIsf ? 'INFO.RESULT.SUCCESS.SUB_TITLE.FILE_ES' : null;
  }

  public get esTitle(): string {
    return this.currES.receivedByCbpDate ? 'INFO.RESULT.SUCCESS.TITLE.YOU_MADE_IT_AGAIN' : 'INFO.RESULT.SUCCESS.TITLE.YOU_MADE_IT';
  }

  public get text(): string {
    return this.isIsf
      ? this.isfText
      : this.isES
      ? this.esText
      : this.isDelivery
      ? 'INFO.RESULT.SUCCESS.TEXT.DELIVERY_WAS_SENT_TO_THE_TRUCKER'
      : this.isBondRequest
      ? 'INFO.RESULT.SUCCESS.TEXT.YOU_CAN_SEE_THE_STATUS_ON_THE_COMPANY_PAGE'
      : '';
  }

  public get esText(): string {
    return this.currES.receivedByCbpDate
      ? 'INFO.RESULT.SUCCESS.TEXT.THE_UPDATE_HAS_BEEN_RESEND'
      : 'INFO.RESULT.SUCCESS.TEXT.YOU_CAN_SEE_THE_STATUS_ON_THE_DASHBOARD';
  }

  public get isfText(): string {
    return this.currIsf.receivedByCbpDate
      ? 'INFO.RESULT.SUCCESS.TEXT.THE_UPDATE_HAS_BEEN_RESEND'
      : 'INFO.RESULT.SUCCESS.TEXT.YOU_CAN_SEE_THE_STATUS_ON_THE_DASHBOARD';
  }

  public get textWarning(): string {
    return this.isIsf ? 'INFO.RESULT.SUCCESS.TEXT_WARNING' : this.isES ? 'INFO.RESULT.SUCCESS.TEXT_WARNING_ES' : '';
  }

  public goToSummary() {
    this.goToEdit.emit();
  }

  public contactToSupport() {
    if (this.isIsf || this.isES || this.isDelivery) {
      const referenceNumber = this.referenceNumber;
      this.widgetsService.trackData('Contact team:', { referenceNumber });
      this.widgetsService.openWidget([this.isIsf ? 'isf' : this.isES ? 'es' : this.isDelivery ? 'delivery' : 'bond request']);
    }
  }

  private checkWarning() {
    if (this.isIsf && [enumIsfState.NOT_VALID_AT_PROVIDER, enumIsfState.UNRECOVERABLE].includes(this.currIsf.state)) {
      this.isWarning = true;
      return;
    }

    if (this.isES && [enumEntrySummaryState.NOT_VALID_PROVIDER, enumEntrySummaryState.UNRECOVERABLE].includes(this.currES.state)) {
      this.isWarning = true;
      return;
    }
  }
}
